import ApiGael from "@/services/apiGael.service";
import ApiAdmin from "@/services/apiAdmin.service";

import {
  FETCH_DASHBOARD_DISCIPLINA,
  FETCH_DASHBOARD_EDUCASPACE,
  FETCH_DASHBOARD_ALUNO_ACCESS,
  FETCH_DASHBOARD_CATALOGO,
  FETCH_DASHBOARD_CURSO,
  FETCH_DASHBOARD_NOVIDADE,
  FETCH_DASHBOARD_RENTS_TIMELINE,
  FETCH_DASHBOARD_PERCENTAGE,
  FETCH_DASHBOARD_BLOG
} from "@/store/actions/actions.type";
import {
  FETCH_DASHBOARD_DISCIPLINA_START,
  FETCH_DASHBOARD_DISCIPLINA_END,
  SET_DASHBOARD_DISCIPLINA,
  FETCH_DASHBOARD_EDUCASPACE_START,
  FETCH_DASHBOARD_EDUCASPACE_END,
  FETCH_DASHBOARD_ALUNO_ACCESS_START,
  FETCH_DASHBOARD_ALUNO_ACCESS_END,
  SET_DASHBOARD_ALUNO_ACCESS,
  FETCH_DASHBOARD_CATALOGO_START,
  FETCH_DASHBOARD_CATALOGO_END,
  SET_DASHBOARD_CATALOGO,
  SET_DASHBOARD_EDUCASPACE,
  FETCH_DASHBOARD_CURSO_START,
  FETCH_DASHBOARD_CURSO_END,
  SET_DASHBOARD_CURSO,
  FETCH_DASHBOARD_NOVIDADE_START,
  FETCH_DASHBOARD_NOVIDADE_END,
  SET_DASHBOARD_NOVIDADE,
  FETCH_DASHBOARD_PERCENTAGE_START,
  FETCH_DASHBOARD_PERCENTAGE_END,
  SET_DASHBOARD_PERCENTAGE,
  FETCH_DASHBOARD_RENTS_TIMELINE_START,
  FETCH_DASHBOARD_RENTS_TIMELINE_END,
  SET_DASHBOARD_RENTS_TIMELINE,
  FETCH_DASHBOARD_BLOG_START,
  FETCH_DASHBOARD_BLOG_END,
  SET_DASHBOARD_BLOG,
} from "@/store/mutations/mutations.type";

const state = {
  dashboards: {
    myDisciplines: {
      total: {
        mainValue: 0,
        subtitleValue: 0
      },
      isFetching: false
    },
    alunos: {
      total: {
        mainValue: 0,
        subtitleValue: 0
      },
      isFetching: false
    },
    catalogo: {
      total: {
        mainValue: 0,
        subtitleValue: 0
      },
      isFetching: false
    },
    educaspace: {
      total: {
        mainValue: 0,
        subtitleValue: 0
      },
      isFetching: false
    },
    curso: {
      total: {
        mainValue: 0,
        subtitleValue: 0
      },
      isFetching: false
    },
    novidades: {
      total: {
        mainValue: 0,
        subtitleValue: 0
      },
      isFetching: false
    },
    rentsTimeline: {
      date: [],
      isFetching: false
    },
    percentage: {
      data: [],
      isFetching: false
    },
    blog: {
      data: [],
      isFetching: false
    },
    novidade: {
      total: {
        mainValue: 0,
        subtitleValue: 0
      },
      isFetching: false
    },
    isFetchingOfflineLinks: false,
    isFetchingTotalLinks: false,
    isFetchingTotalVideos: false
  }
};

const getters = {
  dashboards(state) {
    return state.dashboards;
  }
};

const actions = {
  [FETCH_DASHBOARD_DISCIPLINA](context) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_DISCIPLINA_START);
      ApiAdmin.query("dashboards/cards/mydisciplines")
        .then(response => {
          context.commit(SET_DASHBOARD_DISCIPLINA, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_DISCIPLINA_END);
        });
    });
  },
  [FETCH_DASHBOARD_EDUCASPACE](context) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_EDUCASPACE_START);
      ApiAdmin.query("dashboards/cards/mydisciplines")
        .then(response => {
          context.commit(SET_DASHBOARD_DISCIPLINA, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_EDUCASPACE_END);
        });
    });
  },
  [FETCH_DASHBOARD_ALUNO_ACCESS](context) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_ALUNO_ACCESS_START);
      ApiAdmin.query("dashboards/cards/alunos")
        .then(response => {
          context.commit(SET_DASHBOARD_ALUNO_ACCESS, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_ALUNO_ACCESS_END);
        });
    });
  },
  [FETCH_DASHBOARD_CATALOGO](context,params) {
    return new Promise((resolve, reject) => {
      let isEducaspaceFiltro = false;
      if(params && params.isEducaspaceFiltro)
      {
        isEducaspaceFiltro = true;
      }
      context.commit(FETCH_DASHBOARD_CATALOGO_START);

      // Passa os planos do usuário (mesma fonte do catálogo scout/disciplinas/list)
      // pra contagem do card refletir só os planos liberados. Sem planosId, o
      // backend conta todos os planos.
      const queryParams = { isEducaspaceFiltro };
      if (params && Array.isArray(params.planosId) && params.planosId.length) {
        queryParams.planosId = params.planosId;
      }

      ApiGael.query("dashboards/disciplinas/total", queryParams)
        .then(response => {
          if(isEducaspaceFiltro==true){
            context.commit(SET_DASHBOARD_EDUCASPACE, response.data);
            resolve();
          }else
          {
            context.commit(SET_DASHBOARD_CATALOGO, response.data);
            resolve();
          }
          
        })
        .catch(e => {
          console.log(e);
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_CATALOGO_END);
        });
    });
  },
  [FETCH_DASHBOARD_CURSO](context) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_CURSO_START);
      ApiGael.query("dashboards/cursos/total")
        .then(response => {
          context.commit(SET_DASHBOARD_CURSO, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_CURSO_END);
        });
    });
  },
  [FETCH_DASHBOARD_NOVIDADE](context) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_NOVIDADE_START);
      ApiAdmin.query("dashboards/cards/novidades")
        .then(response => {
          context.commit(SET_DASHBOARD_NOVIDADE, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_NOVIDADE_END);
        });
    });
  },
  [FETCH_DASHBOARD_RENTS_TIMELINE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_RENTS_TIMELINE_START);
      ApiAdmin.query("dashboards/rents-timeline", params)
        .then(response => {
          context.commit(SET_DASHBOARD_RENTS_TIMELINE, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_RENTS_TIMELINE_END);
        });
    });
  },
  [FETCH_DASHBOARD_PERCENTAGE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_PERCENTAGE_START);
      ApiAdmin.query("dashboards/percentage", params)
        // ApiAdmin.query("dashboards/percentage", params)
        .then(response => {
          context.commit(SET_DASHBOARD_PERCENTAGE, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_PERCENTAGE_END);
        });
    });
  },
  [FETCH_DASHBOARD_BLOG](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_DASHBOARD_BLOG_START);
      ApiAdmin.query("dashboards/rss-feed", params)
        .then(response => {
          context.commit(SET_DASHBOARD_BLOG, response.data);
          resolve();
        })
        .catch(e => {
          console.log(e);
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_DASHBOARD_BLOG_END);
        });
    });
  }
};

const mutations = {
  // ------- CATALOGO -------
  [FETCH_DASHBOARD_DISCIPLINA_START](state) {
    state.dashboards.myDisciplines.isFetching = true;
  },
  [SET_DASHBOARD_DISCIPLINA](state, total) {
    state.dashboards.myDisciplines.total = total;
  },
  [FETCH_DASHBOARD_DISCIPLINA_END](state) {
    state.dashboards.myDisciplines.isFetching = false;
  },
  [FETCH_DASHBOARD_ALUNO_ACCESS_START](state) {
    state.dashboards.alunos.isFetching = true;
  },
  [SET_DASHBOARD_ALUNO_ACCESS](state, total) {
    state.dashboards.alunos.total = total;
  },
  [FETCH_DASHBOARD_ALUNO_ACCESS_END](state) {
    state.dashboards.alunos.isFetching = false;
  },
  [FETCH_DASHBOARD_CATALOGO_START](state) {
    state.dashboards.catalogo.isFetching = true;
  },
  [SET_DASHBOARD_CATALOGO](state, total) {
    state.dashboards.catalogo.total = total;
  },
  [SET_DASHBOARD_EDUCASPACE](state, total) {
    state.dashboards.educaspace.total = total;
  },
  [FETCH_DASHBOARD_CATALOGO_END](state) {
    state.dashboards.catalogo.isFetching = false;
  },
  [FETCH_DASHBOARD_CURSO_START](state) {
    state.dashboards.curso.isFetching = true;
  },
  [SET_DASHBOARD_CURSO](state, total) {
    state.dashboards.curso.total = total;
  },
  [FETCH_DASHBOARD_CURSO_END](state) {
    state.dashboards.curso.isFetching = false;
  },
  [FETCH_DASHBOARD_NOVIDADE_START](state) {
    state.dashboards.novidades.isFetching = true;
  },
  [SET_DASHBOARD_NOVIDADE](state, total) {
    state.dashboards.novidades.total = total;
  },
  [FETCH_DASHBOARD_NOVIDADE_END](state) {
    state.dashboards.novidades.isFetching = false;
  },
  [FETCH_DASHBOARD_RENTS_TIMELINE_START](state) {
    state.dashboards.rentsTimeline.isFetching = true;
  },
  [SET_DASHBOARD_RENTS_TIMELINE](state, date) {
    state.dashboards.rentsTimeline.date = date;
  },
  [FETCH_DASHBOARD_RENTS_TIMELINE_END](state) {
    state.dashboards.rentsTimeline.isFetching = false;
  },
  [FETCH_DASHBOARD_PERCENTAGE_START](state) {
    state.dashboards.percentage.isFetching = true;
  },
  [SET_DASHBOARD_PERCENTAGE](state, percentage) {
    state.dashboards.percentage.data = percentage;
    state.percentage = percentage;
  },
  [FETCH_DASHBOARD_PERCENTAGE_END](state) {
    state.dashboards.percentage.isFetching = false;
  },
  [FETCH_DASHBOARD_BLOG_START](state) {
    state.dashboards.blog.isFetching = false;
  },
  [SET_DASHBOARD_BLOG](state, blog) {
    state.dashboards.blog.data = blog;
  },
  [FETCH_DASHBOARD_BLOG_END](state) {
    state.dashboards.blog.isFetching = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
